class SiteElementBindClass
    extends QueryElement<HTMLElement> {

    constructor(card: ISiteCard, element: HTMLElement) {
        super(element, false);

        let path = this.getAttr('data-path');
        let value = card.Model.get((path && SiteModel.split(path)) || []);

        if (value !== undefined && value !== null)
            this.addClass(value);
    }
}